import { Checkbox, CheckboxProps } from 'antd';
import { DateRangePicker, RangeKeyDict } from 'react-date-range';
interface MultipleMonth {
  dateRange?: Date;
  setSingleDate?: (date: Date) => void;
  values: any
  setFieldValue: any;
  setDateErrorMessage: (data: string) => void;
}
export default function MultipleMonth({ values, setFieldValue, setDateErrorMessage }: MultipleMonth) {


  const onChangeHalfDayLeave: CheckboxProps['onChange'] = (e) => {
    setFieldValue("halfDayLeave", e.target.checked);
  };
  const handleSelect = (ranges: RangeKeyDict) => {
    const { startDate, endDate } = ranges?.range1;


    if (startDate && endDate) {
      const rangeDate = {
        startDate: startDate,
        endDate: endDate,
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      const diffMs = end.getTime() - start.getTime();

      const diffDays = diffMs / (1000 * 60 * 60 * 24);
      if (diffDays !== 0) {
        setFieldValue("halfDayLeave", false);
      }

      setFieldValue("leaveDate", rangeDate);
      setDateErrorMessage("");
    } else {
      setDateErrorMessage("Please select a date range");
    }
  };

  const isValidHalfDay = (leaveDate: any) => {
    const start = new Date(leaveDate.startDate);
    const end = new Date(leaveDate.endDate);

    const diffMs = end.getTime() - start.getTime();

    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    // const now = new Date();

    // now.setHours(0, 0, 0, 0);
    // start.setHours(0, 0, 0, 0);
    // let previousDate = false;
    // if (start < now) {
    //   previousDate = true;
    // }
    // if (previousDate) {
    //   return true
    // }
    // else {

    // }
    if (diffDays === 0) {
      return false
    }
    else {
      return true
    }

  }

  return (
    <div className="w-full multiple-month">
      {
        (values?.leaveType === "1" || values?.leaveType === "3") && <>
          <DateRangePicker
            months={2}
            direction="horizontal"
            ranges={[values?.leaveDate]}
            onChange={handleSelect}
            color="#d34a7c"
            rangeColors={["#d34a7c"]}
            className='font-rubik'
          />
          <Checkbox disabled={isValidHalfDay(values?.leaveDate)} checked={values?.halfDayLeave} className=" ml-6 font-rubik half-day-checkbox text-[12px] lg:text-[14px] " onChange={onChangeHalfDayLeave}>Half Day Leave?</Checkbox>
        </>
      }
    </div>
  )
}